module.exports = __webpack_public_path__ + "static/AR9-a6857a6245df52f9d68756b4efce661c.mp4";